import { __assign, __awaiter, __generator } from "tslib";
import { fetchSubEntities } from './http/fetch-sub-entities';
import { SubEntityType } from './models/sub-entity-type';
export var fetchFamilyAwards = function (familyId, country, contentType) { return __awaiter(void 0, void 0, void 0, function () {
    var additionalArguments;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (country) {
                    additionalArguments = { country: country };
                }
                if (contentType) {
                    additionalArguments = __assign(__assign({}, additionalArguments), { contentType: contentType });
                }
                return [4 /*yield*/, fetchSubEntities(familyId, "f" /* Family */, SubEntityType.Awards, additionalArguments)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
